export class MdocsSopsmodel{
    Sopsid:number;
    Path:string;
    Title:string;
    Description:string;
    Status:boolean;
    UnitID:number;
    CreatedDate:Date;
}